import { create } from "zustand";
import { persist } from "zustand/middleware";

interface LocationState {
  selectedLocationId: string;
  selectedLocationName: string;
  setSelectedLocation: (locationId: string, locationName: string) => void;
  clearSelectedLocation: () => void;
}

export const useLocationStore = create<LocationState>()(
  persist(
    (set) => ({
      selectedLocationId: "",
      selectedLocationName: "",
      setSelectedLocation: (locationId: string, locationName: string) =>
        set({
          selectedLocationId: locationId,
          selectedLocationName: locationName,
        }),
      clearSelectedLocation: () =>
        set({ selectedLocationId: "", selectedLocationName: "" }),
    }),
    {
      name: "location-storage",
    },
  ),
);
